class AssetUploadDropZoneController {
  constructor ($log, $rootScope, $timeout, toaster, AssetUploadService, bytesFilter) {
    'ngInject'

    this._$log = $log
    this._$timeout = $timeout
    this._ToastService = toaster
    this._AssetUploadService = AssetUploadService
    this._bytesFilter = bytesFilter

    this.stats = {}
    this._statsListener = $rootScope.$on('asset-upload-service:stats', ($event, stats) => {
      this.stats = stats
    })

    this.conflicts = []
    this.showConflictModal = false
    this._conflictDebounceTimer = null
    this._conflictListener = $rootScope.$on('asset-upload-service:conflict', ($event, conflict) => {
      this.conflicts.push(conflict)

      // Debounce: wait 100ms for more conflicts before showing modal
      if (this._conflictDebounceTimer) {
        this._$timeout.cancel(this._conflictDebounceTimer)
      }
      this._conflictDebounceTimer = this._$timeout(() => {
        if (this.conflicts.length > 0 && !this.showConflictModal) {
          this.showConflictModal = true
        }
      }, 100)
    })

    this.maxFileSize = 419430400 // 400 MB
  }

  /**
   * Hand this controller to the host, which draws the question about a file
   * that already exists. The host needs the conflicts and the two answers.
   */
  $onInit () {
    this.onReady({ $dropZone: this })
  }

  $onDestroy () {
    this._statsListener()
    this._conflictListener()
    if (this._conflictDebounceTimer) {
      this._$timeout.cancel(this._conflictDebounceTimer)
    }
  }

  fileDropped ($files, $file, $newFiles, $duplicateFiles, $invalidFiles) {
    // Notification of invalid files
    for (const file of $invalidFiles) {
      let error
      switch (file.$error) {
        case 'maxSize': {
          error = `File too large (${this._bytesFilter(file.size)}). Max size is ${this._bytesFilter(file.$errorParam)}`
          break
        }

        case 'pattern': {
          error = `File type ${file.type} invalid. File must be image or video.`
          break
        }

        default: {
          error = file.$error
        }
      }

      this._$log.warn(`File rejected: ${file.name}`, { file, error })
      this._ToastService.error(`File rejected: ${file.name}`, error)
    }

    // Initiate upload of files
    for (const file of $files) {
      this._$log.info(`Initiating upload of: ${file.name}`)
      this._AssetUploadService.uploadFile(file)
        .then(() => {
          this._$log.info(`File uploaded: ${file.name}`, { file })
          this._ToastService.success(`File uploaded: ${file.name}`)
        })
        .catch(err => {
          // Don't show error for user cancellations
          if (err.message !== 'Upload cancelled by user') {
            this._$log.warn(`Failed to upload file: ${file.name} - ${err.message}`, { file, error: err })
            this._ToastService.error(`Failed to upload file: ${file.name} `, err.message)
          }
        })
    }
  }

  confirmReplace () {
    this._$log.info(`User confirmed replace for ${this.conflicts.length} file(s)`)
    for (const conflict of this.conflicts) {
      this._AssetUploadService.resolveConflict(conflict, true)
    }
    this.conflicts = []
    this.showConflictModal = false
  }

  cancelUpload () {
    this._$log.info(`User cancelled upload for ${this.conflicts.length} file(s)`)
    for (const conflict of this.conflicts) {
      this._AssetUploadService.resolveConflict(conflict, false)
    }
    this.conflicts = []
    this.showConflictModal = false
  }

  getOrientationText (orientation) {
    return orientation === 'l' ? 'landscape' : 'portrait'
  }
}

export default AssetUploadDropZoneController
